import useAuthService from "@/services/auth.service";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { getUserProfilePhoto } from "@/services/ms-graph-api.service";
import { msalApp } from "@/constants/auth.constant";
import { useEffect, useState } from "react";

/**
 * ProfileIcon component displays the current user's profile picture or avatar.
 * Fetches the user's profile photo from Microsoft Graph API and displays it
 * in an Avatar component. Falls back to user initials if photo is unavailable.
 * 
 * @component
 * @returns {JSX.Element} Avatar component with user profile photo or fallback initials
 * 
 * @example
 * ```tsx
 * <ProfileIcon />
 * ```
 */
export function ProfileIcon() {

  const [image, setImage] = useState<any>('');

  const { getAvatar } = useAuthService();
  const value: any = getAvatar();

  useEffect(() => {
    getUserProfilePhoto(msalApp).then(res => setImage(res))
  }, [value])

  return (
    <Avatar>
      <AvatarImage src={image}></AvatarImage>
      <AvatarFallback className="bg-primary-400 text-white">{value}</AvatarFallback>
    </Avatar>
  );
}
